"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonAdapter = void 0;
const domain_1 = require("@home-health-notify/domain");
const Constants_1 = require("../../Constants");
const Urls_1 = require("../Urls");
class CommonAdapter {
    constructor(httpAdapter, config) {
        this.httpAdapter = httpAdapter;
        this.config = config;
    }
    getSignedUrl(body) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpAdapter.post(this.config.baseUrl + Urls_1.urls.signedUrl, {
                data: Object.assign({}, body),
                event: "get-media-signed-url",
            });
            if (response.status === 200) {
                return response.data.data;
            }
            //TODO: Need to handle other http status codes received from axios.
            else {
                throw new Error(`getSignedUrl => ${response.toString()}`);
            }
        });
    }
    getDepartments(params, organizationId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.department, Object.assign({ params }, (organizationId && {
                    headers: {
                        "x-hhn-active-org-id": organizationId,
                    },
                })));
                if (response.data.hasNext) {
                    const syncErrorInfo = {
                        message: "Departments sync page size exceeded!",
                        search: params.search,
                        limit: params.limit,
                        organizationId,
                    };
                    throw new domain_1.SyncException(syncErrorInfo);
                }
                if (response.status === 200) {
                    return response.data.data.data;
                }
                //TODO: Need to handle other http status codes received from axios.
                else {
                    throw new Error(`Department => ${response.toString()}`);
                }
            }
            catch (e) {
                console.log("Get Department error ==>", e);
                throw e;
            }
        });
    }
    getReferralSource(requestParam, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(this.config.baseUrl +
                    Urls_1.urls.referralSource +
                    this.getQueryString(requestParam), { signal: context === null || context === void 0 ? void 0 : context.newAbortSignal(new AbortController()) });
                return (0, domain_1.CompletedResult)(response.data.data.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                console.log("getReferralSource E ===>", e);
                throw e;
            }
        });
    }
    addReferralSource(name) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const requestData = { name };
                const response = yield this.httpAdapter.post(this.config.baseUrl + Urls_1.urls.referralSource, requestData);
                return (response.data.statusCode &&
                    response.data.statusCode === 200 &&
                    response.data.message === "Success");
            }
            catch (e) {
                console.log("addReferralSource E ===>", e);
                throw e;
            }
        });
    }
    getCommunityLiaisoning(requestParam, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(this.config.baseUrl +
                    Urls_1.urls.communityLiaisoning +
                    this.getQueryString(requestParam), { signal: context === null || context === void 0 ? void 0 : context.newAbortSignal(new AbortController()) });
                return (0, domain_1.CompletedResult)(response.data.data.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                console.log("getCommunityLiaisoning E ===>", e);
                throw e;
            }
        });
    }
    addCommunityLiaisoning(name) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const requestData = { name };
                const response = yield this.httpAdapter.post(this.config.baseUrl + Urls_1.urls.communityLiaisoning, requestData);
                return (response.data.statusCode &&
                    response.data.statusCode === 200 &&
                    response.data.message === "Success");
            }
            catch (e) {
                console.log("addCommunityLiaisoning E ===>", e);
                throw e;
            }
        });
    }
    getQueryString(params) {
        return `?pageNo=${params.pageNo}&limit=${params.limit}&search=${encodeURIComponent(params.search)}`;
    }
    getScheduledVisits(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.scheduleVisit, {
                    params,
                });
                return response.data.data;
            }
            catch (e) {
                console.log("getScheduledVisits E ===>", e);
                throw e;
            }
        });
    }
    updateDeviceToken(requestData) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.httpAdapter.put(this.config.baseUrl + Urls_1.urls.deviceToken, requestData);
            }
            catch (e) {
                console.log("updateDeviceToken E ===>", e);
                throw e;
            }
        });
    }
    clearDeviceToken(deviceToken) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.httpAdapter.post(this.config.baseUrl + Urls_1.urls.clearDeviceToken, {}, { headers: { [Constants_1.ApiHeader.DEVICE_TOKEN]: deviceToken } });
            }
            catch (e) {
                console.log("clearDeviceToken E ===>", e);
                throw e;
            }
        });
    }
}
exports.CommonAdapter = CommonAdapter;
